import type {
	FieldConfig,
	OperationOption,
	UseOptionsQuery,
	ValueState,
} from '../../types'

import { Operators } from '../../constants'
import { stringToArray } from '../../utils/utils'
import FieldController from '../Controller'

type Options = any[]

export default class MultiSelectController extends FieldController {
	constructor(config: FieldConfig) {
		super(config)
		this.useSelectOptions = config.useSelectOptions || this.useSelectOptions
		this.getInitialValue = config.getInitialValue || this.getInitialValue
		this.getFilterTypes = config.getFilterTypes || this.getFilterTypes
	}

	useSelectOptions(): UseOptionsQuery<Options> {
		return {
			data: [],
		}
	}

	hasValue = ({ value }: ValueState) =>
		Array.isArray(value) ? value.length > 0 : !!value

	getInitialValue = () => ({
		operation: Operators.ANY_OF,
		value: [],
	})
	getFilterTypes = (): OperationOption[] => [
		{
			operation: Operators.ANY_OF,
			label: 'any of',
			hasInput: true,
		},
		{
			operation: Operators.ALL_OF,
			label: 'all of',
			hasInput: true,
		},
		{
			operation: Operators.EXACT,
			label: 'exactly',
			hasInput: true,
		},
		{
			operation: Operators.NONE_OF,
			label: 'none of',
			hasInput: true,
		},
		{
			operation: Operators.IS_EMPTY,
			label: 'is empty',
		},
		{
			operation: Operators.IS_NOT_EMPTY,
			label: 'is not empty',
		},
	]
	formatState = ({ operation, value }: ValueState, options?: Options) => {
		if ([Operators.IS_EMPTY, Operators.IS_NOT_EMPTY].includes(operation)) {
			return {
				operation,
				value: '',
			}
		}
		const _value = stringToArray(value || '')
		const selectedOptions = _value?.map(
			(value) =>
				options?.find((o) => value === o.value) || { value, label: value }
		)

		return {
			operation,
			value: selectedOptions.map((o) => o.label).join(', '),
		}
	}
}
